module.exports = __webpack_public_path__ + "static/media/options_icon.772b33ca.svg";